import type { SVGProps } from 'react';

interface UserScanProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

/** 扫描框人像图标（Figma 1170-20359，查看 Polymarket 主页入口） */
export default function UserScan({
  size = 14,
  color = 'currentColor',
  className,
  ...props
}: UserScanProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      {...props}
    >
      <path
        d="M6.99989 6.61111C7.859 6.61111 8.55545 5.91467 8.55545 5.05556C8.55545 4.19645 7.859 3.5 6.99989 3.5C6.14078 3.5 5.44434 4.19645 5.44434 5.05556C5.44434 5.91467 6.14078 6.61111 6.99989 6.61111Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.20117 10.3057C4.70595 9.26966 5.76917 8.55566 6.99962 8.55566C8.23006 8.55566 9.29328 9.26966 9.79806 10.3057"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2498 9.13867V10.6942C12.2498 11.5537 11.5537 12.2498 10.6942 12.2498H9.13867"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.86111 12.2498H3.30556C2.44611 12.2498 1.75 11.5537 1.75 10.6942V9.13867"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 4.86111V3.30556C1.75 2.44611 2.44611 1.75 3.30556 1.75H4.86111"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.13867 1.75H10.6942C11.5537 1.75 12.2498 2.44611 12.2498 3.30556V4.86111"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
